export const commomTableCellProps = {
  sx: {
    fontFamily: "inherit",
    padding: "8px 32px 6px 32px",
    borderColor: "#e2e4ff",
  },
};

export const tableHeadCellProps = {
  sx: {
    ...commomTableCellProps.sx,
    fontWeight: 600,
    "@media (max-width: 768px)": {
      fontSize: 12,
      padding: "8px 8px 6px 16px",
    },
  },
};

export const tableHeadNameCellProps = {
  sx: {
    ...tableHeadCellProps.sx,
    width: "23%",
  },
};

export const tableHeadFormatCellProps = {
  sx: {
    ...tableHeadCellProps.sx,
    width: "20%",
  },
};

export const tableHeadVersionCellProps = {
  sx: {
    ...tableHeadCellProps.sx,
    width: "5%",
    padding: "8px 8px 6px 16px",
  },
};

export const tableHeadSharedAtCellProps = {
  sx: {
    ...tableHeadCellProps.sx,
    width: "17%",
  },
};

export const tableBodyCellProps = {
  sx: {
    ...commomTableCellProps.sx,
    "@media (max-width: 768px)": {
      fontSize: 12,
      padding: "8px 8px 6px 16px",
    },
  },
};
